import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling
} from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appConfigInit } from './app-config-init';
import { loaderInterceptor } from './partials/interceptors/loader.interceptor';
import { errorInterceptor } from './partials/interceptors/error.interceptor';
import { snackBarOptions } from './mat-options';
import { tokenInterceptor } from './partials/interceptors/token.interceptor';
import { authSessionInterceptor } from './partials/interceptors/auth-session.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChunkLoadErrorHandler } from './chunk-load-error.handler';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};
const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // token → auth-session (401 silent re-login + retry) → error snackbar → loader
    provideHttpClient(withInterceptors([tokenInterceptor, authSessionInterceptor, errorInterceptor, loaderInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
        useHttpBackend: true,
      }),
      fallbackLang: 'en',
      lang: 'en',
    }),
    appConfigInit,
    provideAnimationsAsync(),
    provideRouter(routes, withComponentInputBinding(), inMemoryScrollingFeature),
    snackBarOptions,
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler }
  ]
};
